export const QUICK_APPLY_USER = {
  EXIST: 'User is already exist',
  ALREADY_APPLIED: 'You have already applied for a Job'
};
